import { render, staticRenderFns } from "./MtBasicForm.vue?vue&type=template&id=3bf202ee&"
import script from "./MtBasicForm.vue?vue&type=script&lang=js&"
export * from "./MtBasicForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports